export const SEARCH_RESULTS_SESSION_FLAG_VALUE = '1'
